import { API_BASE } from './apiBase';

// Upgrade a bare `/uploads/foo.jpg` reference to the backend proxy path
// `${API_BASE}/api/uploads/foo.jpg`. The proxy path is served with a 1-year
// immutable cache, whereas the bare static path is only cached ~5 minutes.
// Idempotent: absolute URLs, already-`/api/uploads/...` paths and external
// URLs are returned unchanged.
export const toApiUploads = (url) =>
  url && url.startsWith('/uploads/') ? `${API_BASE}/api${url}` : url;

// Same rewrite applied to every `src="/uploads/..."` inside a stored HTML blob
// (e.g. the rich-text Sitges Guide content).
export const rewriteUploadsInHtml = (html) =>
  typeof html === 'string'
    ? html.replace(/(src=["'])\/uploads\//g, `$1${API_BASE}/api/uploads/`)
    : html;
